{
  "title": "Mislead",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level illusion",
  "level": 5,
  "castingTime": "1 action",
  "range": "Self",
  "components": "S",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You become invisible at the same time that an illusory double of you appears where you are standing. The double lasts for the duration, but the invisibility ends if you attack or cast a spell.",
    "You can use your action to move your illusory double up to twice your speed and make it gesture, speak, and behave in whatever way you choose.",
    "You can see through its eyes and hear through its ears as if you were located where it is. On each of your turns as a bonus action, you can switch from using its senses to using your own, or back again. While you are using its senses, you are blinded and deafened in regard to your own surroundings."
  ],
  "spellLists": ["bard", "warlock", "wizard"]
}
